module.exports = __webpack_public_path__ + "media/src/web/images/one-time-offer/left_woman-ec8619608b0cd61faddf62352e75fcab.png";